/* XYRA v9. Shopify renders genuine product cards. This file only paginates,
   filters and sorts them. It never invents products/prices or calls an Admin API. */
(() => {
  'use strict';
  const allowedSorts = ['recommended','title-ascending','price-ascending','price-descending','created-descending'];
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const grid = root.querySelector('[data-browse-grid]');
    const status = root.querySelector('[data-browse-status]');
    const controls = root.querySelector('[data-browse-tools]');
    const pagination = root.querySelector('[data-browse-pagination]');
    const native = root.querySelector('[data-browse-native]');
    const retry = root.querySelector('[data-browse-retry]');
    const empty = root.querySelector('[data-browse-empty]');
    const sort = root.querySelector('[data-browse-sort]');
    const stock = root.querySelector('[data-browse-stock]');
    const minPrice = root.querySelector('[data-browse-min-price]');
    const maxPrice = root.querySelector('[data-browse-max-price]');
    const size = Math.max(1, Number(root.dataset.pageSize) || 24);
    const pageCount = Math.max(1, Number(root.dataset.sourcePages) || 1);
    const sourcePage = Math.max(1, Number(root.dataset.sourcePage) || 1);
    const loadedPages = new Set([sourcePage]);
    const records = new Map();
    let page = 1, type = 'all', complete = false, fetching = false, min = '', max = '';
    const number = value => Number.isFinite(Number(value)) ? Number(value) : 0;
    const format = (text, values) => Object.entries(values).reduce((out,[key,value]) => out.split(`{${key}}`).join(String(value)), text);
    const collator = new Intl.Collator(document.documentElement.lang || 'de', {numeric:true,sensitivity:'base'});
    function collect(scope) {
      scope.querySelectorAll('[data-browse-item]').forEach(node => {
        const id = node.dataset.id;
        if (!id || records.has(id)) return;
        records.set(id, {node,id,title:node.dataset.title || '',price:number(node.dataset.price),created:number(node.dataset.created),available:node.dataset.available === 'true',bucket:node.dataset.bucket || 'other',rank:records.size});
      });
    }
    collect(grid);
    function readState() {
      const params = new URL(location.href).searchParams;
      const desiredType = params.get('xyra_type') || 'all';
      type = root.querySelector(`[data-browse-type="${['all','bags','hats','clothing'].includes(desiredType)?desiredType:'all'}"]`) ? desiredType : 'all';
      if (!['all','bags','hats','clothing'].includes(type)) type = 'all';
      sort.value = allowedSorts.includes(params.get('xyra_sort')) ? params.get('xyra_sort') : 'recommended';
      stock.checked = params.get('xyra_stock') === '1';
      min = params.get('xyra_min') || '';
      max = params.get('xyra_max') || '';
      if (minPrice) minPrice.value = min;
      if (maxPrice) maxPrice.value = max;
      page = Math.max(1, parseInt(params.get('xyra_page') || '1',10) || 1);
    }
    function storeState() {
      const url = new URL(location.href);
      url.searchParams.delete(root.dataset.sourceParam || 'page');
      for (const [key,value,omit] of [['xyra_type',type,type==='all'],['xyra_sort',sort.value,sort.value==='recommended'],['xyra_stock','1',!stock.checked],['xyra_min',min,min===''],['xyra_max',max,max===''],['xyra_page',String(page),page===1]]) {
        if(omit) url.searchParams.delete(key); else url.searchParams.set(key,value);
      }
      // All preview_theme_id, locale paths and view parameters are preserved.
      try { history.pushState({xyra:true},'',url); } catch (_) { /* Restricted previews can block history. */ }
    }
    function render(move=false) {
      if (!complete) return;
      const minCents = min !== '' ? Math.max(0, Math.round(Number(min) * 100)) : null;
      const maxCents = max !== '' ? Math.max(0, Math.round(Number(max) * 100)) : null;
      let result = [...records.values()].filter(row => {
        if (type!=='all' && row.bucket!==type) return false;
        if (stock.checked && !row.available) return false;
        if (minCents !== null && row.price < minCents) return false;
        if (maxCents !== null && row.price > maxCents) return false;
        return true;
      });
      result.sort((a,b) => {
        if(sort.value==='title-ascending') return collator.compare(a.title,b.title);
        if(sort.value==='price-ascending') return a.price-b.price || collator.compare(a.title,b.title);
        if(sort.value==='price-descending') return b.price-a.price || collator.compare(a.title,b.title);
        if(sort.value==='created-descending') return b.created-a.created || collator.compare(a.title,b.title);
        return Number(b.available)-Number(a.available) || collator.compare(a.title,b.title);
      });
      const pages = Math.max(1,Math.ceil(result.length/size));
      page = Math.min(page,pages);
      const start = (page-1)*size;
      grid.replaceChildren(...result.slice(start,start+size).map(row=>row.node));
      controls.hidden = false;
      empty.hidden = result.length !== 0;
      status.textContent = format(root.dataset.countTemplate, {from: result.length ? start+1 : 0,to:Math.min(start+size,result.length),total:result.length});
      root.querySelectorAll('[data-browse-type]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.browseType===type)));
      pagination.hidden = pages<2;
      root.querySelector('[data-browse-prev]').disabled = page<=1;
      root.querySelector('[data-browse-next]').disabled = page>=pages;
      root.querySelector('[data-browse-page]').textContent = format(root.dataset.pageTemplate,{page,pages});
      native.hidden = true;
      if (move) { status.tabIndex=-1;status.focus({preventScroll:true}); status.scrollIntoView({block:'start',behavior:'instant'}); }
      document.dispatchEvent(new CustomEvent('xyra:catalog:updated'));
    }
    function change(reset=true,move=false) {if(reset)page=1;render(move);storeState();}
    controls.addEventListener('click',event=>{const button=event.target.closest('[data-browse-type]');if(!button)return;type=button.dataset.browseType;change();});
    sort.addEventListener('change',()=>change());
    stock.addEventListener('change',()=>change());
    const syncPriceState = () => {
      min = minPrice && minPrice.value !== '' ? String(Math.max(0, Number(minPrice.value) || 0)) : '';
      max = maxPrice && maxPrice.value !== '' ? String(Math.max(0, Number(maxPrice.value) || 0)) : '';
      if (min !== '' && max !== '' && Number(min) > Number(max)) {
        const tmp = min; min = max; max = tmp;
        if (minPrice) minPrice.value = min;
        if (maxPrice) maxPrice.value = max;
      }
    };
    [minPrice, maxPrice].forEach(input => {
      if (!input) return;
      input.addEventListener('change', () => { syncPriceState(); change(); });
      input.addEventListener('keydown', event => {
        if (event.key === 'Enter') { syncPriceState(); change(); }
      });
      input.addEventListener('blur', () => { syncPriceState(); });
    });
    root.querySelector('[data-browse-prev]').addEventListener('click',()=>{page--;change(false,true);});
    root.querySelector('[data-browse-next]').addEventListener('click',()=>{page++;change(false,true);});
    window.addEventListener('popstate',()=>{if(complete){readState();render();}});
    async function load() {
      if(fetching)return;
      fetching=true;retry.hidden=true;root.setAttribute('aria-busy','true');
      if(pageCount>1) status.textContent=root.dataset.loadingText;
      try {
        for(let p=1;p<=pageCount;p++) {
          if(loadedPages.has(p))continue;
          const url=new URL(location.href);
          ['xyra_page','xyra_type','xyra_sort','xyra_stock','xyra_min','xyra_max'].forEach(key=>url.searchParams.delete(key));
          url.searchParams.set(root.dataset.sourceParam || 'page',String(p));
          url.searchParams.set('section_id',root.dataset.sectionId);
          const controller=new AbortController();
          const timer=setTimeout(()=>controller.abort(),18000);
          let response, text;
          try {response=await fetch(url,{credentials:'same-origin',signal:controller.signal,headers:{'Accept':'text/html'}});text=await response.text();}
          finally {clearTimeout(timer);}
          if(!response.ok)throw new Error('Catalogue request failed');
          const doc=new DOMParser().parseFromString(text,'text/html');
          const returned=doc.querySelector('[data-season-catalog]');
          if(!returned || returned.dataset.category!==root.dataset.category || Number(returned.dataset.sourcePage)!==p || Number(returned.dataset.totalSource)!==Number(root.dataset.totalSource))throw new Error('Unexpected catalogue response');
          collect(returned);loadedPages.add(p);
        }
        complete=true;readState();render();
      } catch (_) {
        // Keep the genuine server-rendered page and native next-page links usable.
        complete=false;controls.hidden=true;pagination.hidden=true;native.hidden=false;
        status.textContent=root.dataset.errorText;retry.hidden=false;
      } finally {fetching=false;root.removeAttribute('aria-busy');}
    }
    retry.addEventListener('click',load);load();
  }
  const scan = () => document.querySelectorAll('[data-season-catalog]').forEach(init);
  scan();document.addEventListener('shopify:section:load',scan);
})();
